import { Component } from '@angular/core';
import { ApidataService } from '../apidata.service';
import { CommonModule } from '@angular/common';
import swal from 'sweetalert2';
import { Router } from '@angular/router';
@Component({
  selector: 'app-emailverify',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './emailverify.component.html',
  styleUrl: './emailverify.component.css',
  providers: [ApidataService]
})
export class EmailverifyComponent {
  userid;
  constructor(private api: ApidataService, private router: Router,) {
    this.userid= localStorage.getItem('signupid')

  }

  ngOnInit() {
   this.userid= localStorage.getItem('signupid')

  }
  public againsent_code() {
    this.api.resentcodeforaccount(this.userid).subscribe(data => {
  
      if (data.meta.code == 200) {
        this.showSuccess("Account verification mail resend successfuly.", "");
      }
      if (data.meta.code == 201) {

        swal({
          background: "#FFFFFF",
          title: "success",
          html: `
        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
          background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
          <div class="text-center" style="margin-top: 9%;">
            <img src="/assets/images/paraphrasing tool/success.svg" alt="Alert" />
            <div style="width: 323px; height: 64px; margin-left: 77px;">
              <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
           Account already verified.
              </p>
            </div>
            <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
              border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
              class="butn-alert">Ok</button>
          </div>
        </div>
      `,
          showConfirmButton: false,
          width: "323px",
          timer: 4000
        });

        setTimeout(() => {
          const okButton = document.getElementById('swal-ok-button');
          if (okButton) {
            okButton.addEventListener('click', () => {
              this.router.navigate(['/signin']);
              swal.close();
            });
          }
        }, 0);
      }
      if (data.meta.code == 400) {
        this.sendEmail("leaset try again later.", "");
      }
    })
  }
  error: boolean = false;
  errorAlerts;
  success: boolean = false;
  successAlert;
  resendEmail: boolean = false;
  send;
  sendEmail(message, selector) {
    this.send = message;
    $(selector).css('border-color', 'red');
    this.resendEmail = true;
    $('#errorAlerts;').show();
    setTimeout(() => {
      $('#errorAlerts;').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.resendEmail = false;
    }, 4000);
    let backdrop = document.querySelector('.modal-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show';
      document.body.appendChild(backdrop);
    }
  }

  showAlert(message, selector) {


    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts;').show();
    setTimeout(() => {
      $('#errorAlerts;').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
    let backdrop = document.querySelector('.modal-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show';
      document.body.appendChild(backdrop);
    }
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false;

  }
  closesendDiv() {
    this.resendEmail = false;

  }
}
